import React from 'react';
import { DateFormatters } from 'app/infrastructure/data/types';
import { AdministrationMessagesTranslation } from '../../constants';
import { UpdateHandler, DeleteHandler } from '../types';
import { AdministrationListMessage } from '../types-store';
import { MessagesListItem } from './messages-list-item';

interface MessagesListItemsProps {
  messages: AdministrationListMessage[];
  canEdit: boolean;
  canDelete: boolean;
  includeInactive: boolean;
  updatingMessages: number[];
  updateMessage: UpdateHandler;
  deleteMessage: DeleteHandler;
  translation: AdministrationMessagesTranslation;
  formatters: DateFormatters;
}

export const MessagesListItems: React.FC<MessagesListItemsProps> = ({
  messages, canEdit, canDelete, includeInactive, updatingMessages, updateMessage, deleteMessage, translation, formatters
}) => {

  return messages && messages.length > 0
    ? <>
      {messages.map(message => <MessagesListItem
        key={message.id}
        message={message}
        canEdit={canEdit}
        canDelete={canDelete}
        includeInactive={includeInactive}
        updating={updatingMessages.includes(message.id)}
        updateMessage={updateMessage}
        deleteMessage={deleteMessage}
        translation={translation}
        formatters={formatters}
      />)}
    </>
    : null;
};
